(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55],{

/***/ 296:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs",
      function () {
        return __webpack_require__(7449);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _loaders_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5876);
/* harmony import */ var _loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_loaders_module_css__WEBPACK_IMPORTED_MODULE_1__);


var SimpleLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default().simpleLoader),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_loaders_module_css__WEBPACK_IMPORTED_MODULE_1___default().loader)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleLoader);


/***/ }),

/***/ 7449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(9815);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_blogCategories__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2698);
/* harmony import */ var _components_blog_BlogCategoryBar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(254);
/* harmony import */ var _components_blog_BlogHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3549);
/* harmony import */ var _components_cards_BlogCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(505);
/* harmony import */ var _components_blog_BlogsGrid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2999);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_urls__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1510);
/* harmony import */ var _components_loader_SimpleLoader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8785);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7814);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1436);
/* harmony import */ var _utils_blogText_json__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(998);
/* harmony import */ var _utils_blogsHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(4643);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(6968);




















var Blogs = function() {
    var limit = 6;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), page = ref[0], setPage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), categories = ref1[0], setCategories = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), blogs = ref2[0], setBlogs = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), categoryData = ref4[0], setCategoryData = ref4[1];
    var params = router.query;
    var isSubCategory = params.category;
    var isReady = router.query;
    var getNextBlogs = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var url, res;
            return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        url = _utils_urls__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?index=0&limit=6&minimal=true";
                        if (params.search) url = url + "&searchQuery=" + params.search;
                        else if (params.category && params.subcategory) {
                            url = url + "&category=".concat(params.category, "&subcategory=").concat(params.subcategory);
                        } else if (params.category) {
                            url = url + "&category=".concat(params.category);
                        }
                        url = _utils_urls__WEBPACK_IMPORTED_MODULE_10__/* ["default"].get_blogApi.url */ .Z.get_blogApi.url + "?index=" + page * limit + "&limit=" + limit;
                        setLoading(true);
                        _ctx.next = 7;
                        return axios__WEBPACK_IMPORTED_MODULE_9___default().get(encodeURI(url));
                    case 7:
                        res = _ctx.sent;
                        if (page === 0) {
                            setBlogs(res.data);
                        } else {
                            setBlogs((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(blogs).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(res.data)));
                        }
                        setPage(page + 1);
                        setLoading(false);
                        _ctx.next = 16;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        setLoading(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function getNextBlogs() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var getBlogs = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var data;
                return _vercel_path0_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setLoading(true);
                            _ctx.next = 4;
                            return (0,_utils_blogsHelper__WEBPACK_IMPORTED_MODULE_15__/* .fetchBlogs */ .J$)(params);
                        case 4:
                            data = _ctx.sent;
                            setBlogs(data);
                            setPage(1);
                            setLoading(false);
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            setLoading(false);
                        case 13:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }));
            return function getBlogs() {
                return _ref.apply(this, arguments);
            };
        }();
        if (params.category) {
            setCategories(_utils_blogCategories__WEBPACK_IMPORTED_MODULE_4__/* .blogCatandSub */ .S[params.category]);
        } else {
            setCategories(_utils_blogCategories__WEBPACK_IMPORTED_MODULE_4__/* .rootCategories */ .K);
        }
        if (router.isReady) {
            getBlogs();
        }
    }, [
        params,
        router.isReady
    ]);
    var categoryHandler = function(id) {
        console.log(id, params);
        if (params.subcategory) {
            router.push("/blogs/category/".concat(params.category, "?subcategory=").concat(id));
        } else {
            router.push("/blogs/category/".concat(id));
        }
    };
    var categoryResetHandler = function() {
        router.push("/blogs");
    };
    var blogTextHandler = function() {
        if (params.category && params.subcategory) {
            var y = _utils_blogText_json__WEBPACK_IMPORTED_MODULE_14__.filter(function(b) {
                return b.category === params.category && b.subcategory === params.subcategory;
            });
            if (y.length === 1) {
                return y[0].text;
            } else {
                var x = _utils_blogText_json__WEBPACK_IMPORTED_MODULE_14__.filter(function(b) {
                    return b.category === params.category;
                });
                return x[0].text;
            }
        } else if (params.category) {
            var y1 = _utils_blogText_json__WEBPACK_IMPORTED_MODULE_14__.filter(function(b) {
                return b.category === params.category;
            });
            return y1[0].text;
        } else {
            return "Read On";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_12___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "Blogs | Success Stories, Health & Expert Tips"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: "Stay up-to-date with everything happening in the Optimum Wellness community as well as a curated space for promoting general health and wellbeing. Explore latest articles featuring useful guides on nutrition, fitness hacks, and more!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: "fitness, health, wellness"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center fo40 fw800 mfo32 mt-4",
                id: "blogPage_heading",
                style: {
                    fontWeight: "800",
                    fontSize: "2.1rem"
                },
                children: params.category != null && params.subcategory != null ? params.subcategory : params.category != null ? params.category : "Blogs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center fo20 fw600",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                    src: params.category && params.subcategory ? encodeURI("https://assets.alanvidyushbaptist.com/icons/".concat(params.subcategory, " Purple.png")) : params.category ? encodeURI("https://assets.alanvidyushbaptist.com/icons/".concat(params.category, " Purple.png")) : "https://assets.alanvidyushbaptist.com/icons/Blog_Purple.png",
                    alt: "icon",
                    height: "60px",
                    width: "60px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-center fo15 txtco mfo13",
                children: blogTextHandler()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "dynamicPageSection",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    className: "allBlogsSection",
                    children: [
                        isReady && !params.search && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: "navbar navbar-expand-xl mt-4 p-0 blogCategoryNavbar",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "d-block d-xl-none text-white py-3 px-4 fw-600 fo-20",
                                            children: "TOPICS"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            className: "navbar-toggler collapsed",
                                            type: "button",
                                            "data-bs-toggle": "collapse",
                                            "data-bs-target": "#collapsibleBlogCategories",
                                            "aria-expanded": "false",
                                            "aria-controls": "collapsibleBlogCategories",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_13__/* .FontAwesomeIcon */ .G, {
                                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_18__/* .faChevronDown */ .ptq,
                                                className: "fo-20 fw-600 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_blog_BlogCategoryBar__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            params: params,
                                            categories: categories,
                                            onClick: categoryHandler,
                                            resetHandler: categoryResetHandler,
                                            selected: params.subcategory || params.category
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_blog_BlogHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    blogs: blogs
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "categoryBasedBlogs",
                            children: [
                                blogs && blogs.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "row m-0 mt-3",
                                            id: "displayAllBlogs",
                                            children: blogs.map(function(blog, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_cards_BlogCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                    blog: blog
                                                }, "root_blogs_card_" + index);
                                            })
                                        }),
                                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "d-flex justify-content-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                animation: "border"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "text-center mt-5 homeBottom",
                                            id: "readmorebutton",
                                            children: limit * page <= blogs.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                className: "btn showMoreButton",
                                                onClick: getNextBlogs,
                                                children: "READ MORE"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "fo-18 fw-600 text-center",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    children: "Revisit us again for more!"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                _utils_blogCategories__WEBPACK_IMPORTED_MODULE_4__/* .rootCategories.map */ .K.map(function(cat, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_blog_BlogsGrid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                        category: cat.name
                                    }, index);
                                }),
                                !loading && blogs && blogs.length <= 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                    className: "text-center",
                                    children: "No Blogs Found"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Blogs);


/***/ }),

/***/ 5876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"simpleLoader":"loaders_simpleLoader__YHLAr","loader":"loaders_loader__wvx3u","loaderc":"loaders_loaderc__gH_A7","rotation":"loaders_rotation__Texb1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [217,776,774,888,179], function() { return __webpack_exec__(296); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);